import {
  ReactNode,
  createContext,
  useCallback,
  useEffect,
  useState,
} from 'react'

import { ICompanySegmentAlias } from '../sdk/company/company.types'
import { sdk } from '../services/sdk'

interface SegmentsContextData {
  segments: ICompanySegmentAlias[]
}

interface SegmentsDataProps {
  children: ReactNode
}

export const SegmentsDataContext = createContext({} as SegmentsContextData)

export function SegmentsDataProvider(props: SegmentsDataProps) {
  const [segments, setSegments] = useState<ICompanySegmentAlias[]>([])

  const fetchSegments = useCallback(async () => {
    const _segments = await sdk.company.getAllSegments()
    setSegments(_segments)
  }, [])

  useEffect(() => {
    fetchSegments()
  }, [fetchSegments])

  return (
    <SegmentsDataContext.Provider
      value={{
        segments,
      }}
    >
      {props.children}
    </SegmentsDataContext.Provider>
  )
}
